import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { Product } from '../types/product';

export function useProduct(id: string | null) {
  return useQuery({
    queryKey: ['product', id],
    queryFn: () => api<Product>(`/products/${id}`),
    enabled: !!id,
  });
}
